<template>
  <div class="container">
    <div class="header" :class="{shadow:shadow}">
      <div class="title">
        <div class="t-text">
          <img src="./../../assets/image/simulation/text-1.png" alt="">
        </div>
        <div class="t-icon">
          <img src="./../../assets/image/simulation/loading.png" alt="">
        </div>
      </div>
    </div>
    <div class="main">
      <div class="main-view">
        <div class="voiceover" v-for="(item,index) in task" :key="index" :class="{resolve:item.resolve}">
          <div class="title">
            <img :src="item.title" alt="">
          </div>
          <div class="content">
            <p v-for="PItem in item.items" :key="PItem">
              {{PItem}}
            </p>
            <div class="status">
              {{item.resolve?'已完成':'未完成'}}
            </div>
          </div>
        </div>
        <div style="display: flex;justify-content: flex-end;padding-right: 30px">
          <el-button @click="toNext" type="danger" v-show="nextShow" style="font-size: 18px;font-weight: bolder">
            任务已全部完成，去编辑产品吧
          </el-button>
        </div>
      </div>
    </div>
    <div class="footer">
    
    </div>
  </div>
</template>

<script>
  import txt1  from './../../assets/image/simulation/txt1.png'
  import txt2  from './../../assets/image/simulation/txt2.png'
  import txt3  from './../../assets/image/simulation/txt3.png'
  import txt4  from './../../assets/image/simulation/txt4.png'
  export default {
    name: "meeting-minutes",
    data() {
      return {
        shadow: false,
        task: [
          {
            title: txt1,
            items: [
              "● 消费力是指网购客户的消费能力，一般从平台卖家产品定价密集度进行分析；",
              "● 调查分析该品类一个平台上价格的平均价格。",
              "● 调查单个SKU订单集中销售量和单个SKU的平均价格。"
            ],
            resolve: false
          },
          {
            title: txt3,
            items: [
              "● 总销量是指一个品类上架产品的销量总和；",
              "● 分析平台所有卖家一段时期的该品类销售总量。",
              "● 也可以分析单个SKU销量总；",
              "● 总销量高而卖家数量也多，说明该产品有销量但价格竞争激烈；",
              "● 总销量高而卖家数量少，有可能头部品牌卖家形成，综合其他要素进行判断。"
            ],
            resolve: false
          },
          {
            title: txt2,
            items: [
              "● 卖家数量是指调查一个产品上架卖家的总数量；",
              "● 卖家数量的多寡，可以判断该产品销量的热度；",
              "● 产品的集中上架时间，卖家数量、订单总销量几个维度综合，可以分析该产品热卖走势，培育潜力款。"
            ],
            resolve: false
          },
          {
            title: txt4,
            items: [
              "● 评论数是指客户对已销售订单的评论/评价数量总和；",
              "● 通过卖家评论数量可以判断产品的热卖程度；",
              "● 根据客户评价内容进行产品的优化或更新；"
            ],
            resolve: false
          },
        ]
      }
    },
    computed: {
      nextShow() {
        return this.task.filter((i) => (i.resolve)).length === 4
      }
    },
    mounted() {
      this.updateTaskStatus()
      document.querySelector('.main-view').addEventListener('scroll', (e) => {
        this.shadow = Boolean(e.target.scrollTop > 0)
      })
    },
    methods: {
      toNext() {
        this.$router.push({
          path: '/simulationComparison',
          query: this.$route.query
        })
      },
      updateTaskStatus() {
        let arr = [3, 4, 5, 6]
        arr.forEach((item, index) => {
          this.task[index].resolve = localStorage.getItem(this.$route.query.id + '-chartComponent' + item)
            ? JSON.parse(localStorage.getItem(this.$route.query.id + '-chartComponent' + item)).resolve
            : false
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .container {
    height: 760px;
    width: 550px;
    border: 3px solid #638FD8;
    box-sizing: content-box;
    border-radius: 10px;
    
    .header {
      height: 120px;
      text-align: center;
      padding: 10px 0 10px 0;
      
      &.shadow {
        transition: all 0.3s linear;
        box-shadow: 0 10px 10px 0 rgba(158, 158, 158, 0.2);
      }
      
      .title {
        .t-text {
        
        }
      }
    }
    
    .main {
      height: calc(100% - 120px);
      overflow: hidden;
      
      .main-view {
        margin-right: -17px;
        overflow-y: scroll;
        height: 100%;
        //box-shadow: -10px -10px 10px -6px rgba(158,158,158,0.8) inset;
      }
      
      .voiceover {
        display: flex;
        margin: 22px 30px;
        padding: 10px;
        border-radius: 10px;
        font-size: 16px;
        color: #9e9e9e;
        background: #e9ecef;
        box-shadow: 7px 7px 12px rgba(162, 162, 162, 0.4), -7px -7px 12px rgba(255, 255, 255, 0.9);
        
        &.resolve {
          color: #ffffff;
          background: #2196f3;
          box-shadow: 7px 7px 12px rgba(162, 162, 162, 0.4), -7px -7px 12px rgba(255, 255, 255, 0.9);
        }
        
        .title {
          flex-grow: 0;
          flex-shrink: 0;
          flex-basis: 86px;
          font-size: 16px;
          img {
            width: 86px;
          }
        }
        
        .content {
          flex-grow: 1;
          flex-shrink: 1;
          font-size: 15px;
          line-height: 18px;
          
          .status {
            display: flex;
            justify-content: flex-end;
            font-size: 18px;
            font-weight: bolder;
            color: #ff5722;
          }
        }
        
        .footer {
        
        }
      }
      
      .chat-box {
        padding: 0 20px;
        display: flex;
        margin-bottom: 16px;
        
        &.chat-left {
          .chat-content {
            margin-left: 40px;
            
            &:before {
              content: '';
              position: absolute;
              left: -42px;
              top: 30px;
              border-left: 20px solid transparent;
              border-top: 20px solid transparent;
              border-right: 20px solid #638fd8;
              border-bottom: 20px solid transparent;
            }
            
            &:after {
              content: '';
              position: absolute;
              left: -38px;
              top: 30px;
              border-left: 20px solid transparent;
              border-top: 20px solid transparent;
              border-right: 20px solid #FFFFFF;
              border-bottom: 20px solid transparent;
            }
          }
        }
        
        &.chat-right {
          .chat-content {
            margin-right: 40px;
            
            &:before {
              content: '';
              position: absolute;
              right: -42px;
              top: 30px;
              border-left: 20px solid #638fd8;
              border-top: 20px solid transparent;
              border-right: 20px solid transparent;
              border-bottom: 20px solid transparent;
            }
            
            &:after {
              content: '';
              position: absolute;
              right: -38px;
              top: 30px;
              border-left: 20px solid #FFFFFF;
              border-top: 20px solid transparent;
              border-right: 20px solid transparent;
              border-bottom: 20px solid transparent;
            }
          }
        }
        
        .chat-portrait {
          width: 100px;
          height: 100px;
          flex-shrink: 0;
          flex-grow: 0;
          
          > img {
            width: 100%;
            height: 100%;
          }
        }
        
        .chat-content {
          font-size: 14px;
          line-height: 16px;
          position: relative;
          border: 3px solid #638FD8;
          border-radius: 10px;
          padding: 16px;
          flex-grow: 1;
          flex-shrink: 1;
          
        }
      }
    }
    
    .footer {
      box-shadow: 0 10px 10px 0 rgba(158, 158, 158, 0.2);
    }
  }
</style>
